<section class="vet o-page">
	<section class="o-page__heading vet__heading">
		<h1
			class="c-page-heading"
			data-quat="value_newVetHeading"
		>Add a Vet Clinic for {{ petName$ | async }}</h1>
		<p class="c-radio-group__description-heading vet__subheading">Enter your vet clinic's contact information</p>
	</section>
	<form
		[formGroup]="newClinicForm"
		class="vet__form o-page__content"
	>
		<section class="vet__actions">
			<mv-back-button
				label="Cancel, Back to Search"
				iconSize="2.4rem"
				(click)="stepBack()"
			></mv-back-button>
		</section>
		<div
			role="presentation"
			class="c-input-group m--legacy"
		>
			<label
				for="name"
				class="c-input-group__label"
				data-quat="label_name"
			>Vet Clinic Name</label>
			<input
				formControlName="name"
				type="text"
				name="name"
				id="name"
				class="c-input-group__input vet__input m--name"
				data-quat="input_name"
			>
		</div>
		<div
			role="presentation"
			class="c-input-group m--legacy"
		>
			<label
				for="streetAddress"
				class="c-input-group__label"
				data-quat="label_streetAddress"
			>Vet Clinic Street Address</label>
			<input
				formControlName="streetAddress"
				type="text"
				name="streetAddress"
				id="streetAddress"
				class="c-input-group__input vet__input m--street"
				data-quat="input_streetAddress"
			>
		</div>
		<div
			role="presentation"
			class="vet__input-row"
		>
			<div
				role="presentation"
				class="c-input-group m--legacy"
			>
				<label
					for="zipCode"
					class="c-input-group__label"
					data-quat="label_zipCode"
				>Zip Code</label>
				<input
					formControlName="zipCode"
					mvPreventAlpha
					type="text"
					name="zipCode"
					minlength="5"
					maxlength="5"
					inputmode="numeric"
					id="zipCode"
					class="c-input-group__input vet__input m--zip-code"
					data-quat="input_zipCode"
				>
			</div>
			<div
				role="presentation"
				class="c-input-group m--legacy"
			>
				<label
					for="state"
					class="c-input-group__label"
					data-quat="label_state"
				>State</label>
				<input
					formControlName="state"
					[matAutocomplete]="stateList"
					type="text"
					name="state"
					id="state"
					class="c-input-group__input vet__input m--state"
					data-quat="input_state"
					(blur)="checkForSelection()"
				>
				<mat-autocomplete
					#stateList="matAutocomplete"
					[autoActiveFirstOption]="true"
				>
					<mat-option
						*ngFor="let state of filteredStates$ | async"
						[value]="state.abbreviation"
						[attr.data-quat]="'input_stateOption' + state.abbreviation"
					>{{ state.abbreviation }}&mdash;{{ state.name }}</mat-option>
				</mat-autocomplete>
			</div>
		</div>
		<div
			role="presentation"
			class="c-input-group m--legacy"
		>
			<label
				for="phoneNumber"
				class="c-input-group__label"
				data-quat="label_phoneNumber"
			>Phone Number</label>
			<input
				formControlName="phone"
				type="text"
				name="phoneNumber"
				minlength="10"
				maxlength="10"
				inputmode="tel"
				id="phoneNumber"
				class="c-input-group__input vet__input m--phone"
				data-quat="input_phoneNumber"
			>
		</div>
		<button
			[disabled]="newClinicForm.invalid"
			type="button"
			class="c-cta vet__cta"
			data-quat="action_nextStep"
			(click)="nextStep()"
		>Next</button>
	</form>
	<section class="c-workflow-actions o-page__actions">
		<span aria-hidden="true"></span>
		<mv-cancel-button
			class="c-workflow-actions__item m--end"
			(click)="cancel()"
		></mv-cancel-button>
	</section>
</section>